import gql from 'graphql-tag'

export const QUERY_GET_USERS = gql`
  query getPlatformUsers($page: Int, $pageSize: Int, $search: String) {
    getPlatformUsers(page: $page, pageSize: $pageSize, search: $search) {
      page
      records
      users {
        _id
        name
        email
        active
        emailConfirmed
        phone
        lastSession {
          createdAt
        }
        permissions {
          crm {
            accessSensitiveData
            accessSensitiveDataEmployees
            downloadSensitiveDataPermission
            permissions
          }
          ecommerce {
            permissions
          }
        }
      }
    }
  }
`

export const QUERY_GET_USER = gql`
  query getPlatformUser($email: String!) {
    getPlatformUser(email: $email) {
      name
      email
      active
      phone
      permissions {
        storeAccess {
          ecommerce
          crm
        }
        stores {
          id
          accountId
          ecommerce
          club
        }
        ecommerce {
          roles
          permissions
        }
        crm {
          roles
          permissions
          accessSensitiveData
          accessSensitiveDataEmployees
          downloadSensitiveDataPermission
        }
      }
      notificationConfigurations {
        availableIndustryCampaigns {
          whatsappBusinessAPI
          email
        }
      }
    }
  }
`

export const MUTATION_UPDATE_SELF_NOTIFICATION_CONFIGURATIONS = gql`
  mutation updateSelfPlatformUserNotificationConfiguration($notificationConfigurations: PlatformUserNotificationConfigurationsInput!) {
    updateSelfPlatformUserNotificationConfiguration(notificationConfigurations: $notificationConfigurations) {
      id
    }
  }
`

export const MUTATION_CREATE_USER = gql`
  mutation createPlatformUserAuth($permissionValue: PlatformUserPermissionsInput, $name: String!, $email: String!, $password: String!, $phone: String) {
    createPlatformUserAuth(permissions: $permissionValue, name: $name, email: $email, password: $password, phone: $phone) {
      id
    }
  }
`

export const MUTATION_UPDATE_USER = gql`
  mutation updatePlatformUserAuth(
    $permissionValue: PlatformUserPermissionsInput
    $name: String!
    $email: String!
    $newEmail: String
    $active: Boolean
    $password: String
    $phone: String
  ) {
    updatePlatformUserAuth(
      permissions: $permissionValue
      name: $name
      email: $email
      newEmail: $newEmail
      active: $active
      password: $password
      phone: $phone
    ) {
      id
    }
  }
`

export const QUERY_GET_NAVIGATION_LOGS = gql`
  query PlatformUserTracks($userId: ID!, $page: Int, $pageSize: Int, $sort: [String], $sortDirection: [SortDirection], $search: String) {
    platformUserTracks(userId: $userId, page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection, search: $search) {
      records
      page
      platformUserTracks {
        route
        genericRoute
        createdAt
      }
    }
  }
`

export const QUERY_GET_AGGREGATED_NAVIGATION_LOGS = gql`
  query AggregatePlatformUserTrackMetrics($startDate: String!, $endDate: String!, $groupBy: MetricGroupBy!) {
    aggregatePlatformUserTrackMetrics(startDate: $startDate, endDate: $endDate, groupBy: $groupBy) {
      user {
        email
      }
      metrics {
        startDate
        endDate
        count
      }
    }
  }
`
